import React from 'react';
import classNames from 'classnames';
import {Dummy} from '../'
import styles from './style.css';

export default class WinterSummer extends Dummy {

    render() {
        let modeClass = {};

        if (!this.props.winter.disabled) {
            modeClass[styles.summer] = !this.props.winter.cleaned;
            modeClass[styles.winter] = this.props.winter.cleaned;
        }
        modeClass[styles.disabled] = this.props.winter.disabled;

        return (
            <div id={this.props.div_id} className={styles.mode}>
                <p>Режим</p>
                <div className={classNames(modeClass)}/>
            </div>
        );
    }
}

WinterSummer.propTypes = {
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/WinterSummer/index.jsx